// extracted by mini-css-extract-plugin
export default {"favi":"keywordSuggestionsPage_favi__S0op8","tabWrapper":"keywordSuggestionsPage_tabWrapper__5xClq","tabTitle":"keywordSuggestionsPage_tabTitle__OBrj2"};